"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const tab_style_1 = __importDefault(require("./tab.style"));
const store_1 = require("store");
const material_1 = require("@mui/material");
const TabsComponent = ({ tabs = [{ labels: 'Tab 1', index: 0 }], onChangeTab = () => {
    console.log('add new');
}, }) => {
    const [value, setValue] = react_1.default.useState(0);
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const onHandleChange = (val) => {
        setValue(val);
        const dataFilter = tabs === null || tabs === void 0 ? void 0 : tabs.find((t) => t.index == val);
        onChangeTab(dataFilter ? dataFilter.labels : '');
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Tabs, Object.assign({ value: value, style: { minWidth: 'max-content' }, onChange: (event, newValue) => {
            onHandleChange(newValue);
        } }, { children: tabs.map((tab, index) => ((0, jsx_runtime_1.jsx)(material_1.Tab, { "aria-label": 'ant example', style: tab_style_1.default.tabStyle(appTheme), label: tab.labels }, index))) })));
};
exports.default = TabsComponent;
